export default "__VITE_ASSET__Bg$kqRnk__"